export default __webpack_public_path__ + "static/media/SAS Alert Tone 24.1eb1332f.wav";